import Utilities from '@/Utility/Utilities';

let htmlEscapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#47;',
    '`': '&#96;',
}

/**
* Maskiert die für HTML relevanten Sonderzeichen in einem String. Das &-Zeichen kann ignoriert werden, da es ebenfalls in der kodierten
* Darstellung auftritt (relevant wenn ein bereits maskierter String erneut maskiert wird).
*/
export function escapeHtml(originalText: string, ignoreAmpersand: boolean): string {
    if (typeof originalText != "string")
        return originalText;

    if (Utilities.isNullOrUndefined(originalText))
        return '';

    let regexText = '';
    let prop;

    for (prop in htmlEscapeMap) {
        if (htmlEscapeMap.hasOwnProperty(prop)) {

            if (ignoreAmpersand && prop === '&') {
                continue;
            }

            regexText += prop;
        }
    }

    regexText = `[${regexText}]`;
    const regex = new RegExp(regexText, 'g');

    return originalText.replace(regex, (s) => {
        return htmlEscapeMap[s];
    });
}

/*
    * Ersetzt Leerzeichen alternierend durch Leerzeichen und maskierte Leerzeichen. Dadurch ist es möglich in HTML mehrere Leerzeichen hinterienander
    * zu rendern, wobei Zeilenumbrüche trotzdem weiterhin automatisch an den echten Leerzeichen erfolgen können.
    */
export function escapeWhitespacesAlternating(originalText: string): string {
    if (Utilities.isNullOrUndefined(originalText))
        return '';

    return originalText.replace(/  /g, ' \u00a0');
}

/*
    * Ersetzt Zeilenumbrüche durch das entsprechende HTML-Tag.
    */
export function replaceNewLineWithHtmlTag(originalText: string): string {
    if (Utilities.isNullOrUndefined(originalText))
        return '';

    return originalText.replace(/(?:\r\n|\r|\n)/g, '<br>');
}

export default {
    replaceNewLineWithHtmlTag,
    escapeWhitespacesAlternating,
    escapeHtml
}